
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as ReferralAVkqksM_450vg74UT7wgj5Hxagi1oiBnjajcHyj32GkAAMeta } from "/app/pages/Referral.vue?macro=true";
import { default as WidgetWynDAcRyZMCr9ZMvAzQwQmfKZymp_45m8k_45tSG7sVFFQYMeta } from "/app/pages/[_lang]/Widget.vue?macro=true";
import { default as LeadI2hdQjexEEW804r3j2ORmIqDS64wN0ln4ObrB4T0MqwMeta } from "/app/pages/[_lang]/[_city]/Lead.vue?macro=true";
import { default as Options_454lg04Q4KCAty4js1WyI6pGFO4Vt3D1FGsq_U6Sv4vcMeta } from "/app/pages/[_lang]/[_city]/Options.vue?macro=true";
import { default as Category80ncEB0LLpTwTMVsojF_z3a_m4vGDUfG2vp97gULIZEMeta } from "/app/pages/[_lang]/[_city]/Category.vue?macro=true";
import { default as CoveragenfrRAuv2emleKysFTtuJ89sXS6e8XhTaJsJLctnt0JMMeta } from "/app/pages/[_lang]/[_city]/Coverage.vue?macro=true";
import { default as PersonaluZmrjRSXNOHjYHhaVkx3sFem2AFWULtWCoTrQ9uo19cMeta } from "/app/pages/[_lang]/[_city]/Personal.vue?macro=true";
import { default as dateWTIvyk3znnKOL6UxYYsiuma5MXnNkxtZK9ECftxBXmsMeta } from "/app/pages/webview/[_lang]/[_city]/date.vue?macro=true";
import { default as Final88dCcBfMrk3QT_4512qFwUk1Bpw4bRDVdBXIMI6u2h5hUMeta } from "/app/pages/webview/[_lang]/[_city]/Final.vue?macro=true";
import { default as OptionslubZpzDUrO_45Qwr_45jGQLEYc_45MrTON6SdWOdqV3Zn5hS0Meta } from "/app/pages/webview/[_lang]/[_city]/Options.vue?macro=true";
import { default as SummarysrlaR9EQ8MpbUuKGYgNbalnCb2EjB1SknJIBrLF_45_45YAMeta } from "/app/pages/webview/[_lang]/[_city]/Summary.vue?macro=true";
import { default as Categoryxh0ZlB4Lo8KCfAgdSznBWPqipoOe550Q_lyJs_45Qk9DoMeta } from "/app/pages/webview/[_lang]/[_city]/Category.vue?macro=true";
import { default as Coverage0u8RwHPfRHfQXBn_rqWRAMisf8xWgAdTfx5_459NIrG6wMeta } from "/app/pages/webview/[_lang]/[_city]/Coverage.vue?macro=true";
import { default as select7k7JIfhwNhutI578stcJp4JF_RcsNFITIhbCOjnhykEMeta } from "/app/pages/webview/[_lang]/[_city]/service/select.vue?macro=true";
import { default as onboarding_PKGOFRkvCziv5ey_45nLcAceI29kGuPZDSkwa9MaIyZwMeta } from "/app/pages/webview/[_lang]/[_city]/service/onboarding.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "Referral",
    path: "/Referral",
    component: () => import("/app/pages/Referral.vue")
  },
  {
    name: "_lang-Widget",
    path: "/:_lang()/Widget",
    meta: WidgetWynDAcRyZMCr9ZMvAzQwQmfKZymp_45m8k_45tSG7sVFFQYMeta || {},
    component: () => import("/app/pages/[_lang]/Widget.vue")
  },
  {
    name: "_lang-_city-Lead",
    path: "/:_lang()/:_city()/Lead",
    component: () => import("/app/pages/[_lang]/[_city]/Lead.vue")
  },
  {
    name: "_lang-_city-Options",
    path: "/:_lang()/:_city()/Options",
    component: () => import("/app/pages/[_lang]/[_city]/Options.vue")
  },
  {
    name: "_lang-_city-Category",
    path: "/:_lang()/:_city()/Category",
    component: () => import("/app/pages/[_lang]/[_city]/Category.vue")
  },
  {
    name: "_lang-_city-Coverage",
    path: "/:_lang()/:_city()/Coverage",
    component: () => import("/app/pages/[_lang]/[_city]/Coverage.vue")
  },
  {
    name: "_lang-_city-Personal",
    path: "/:_lang()/:_city()/Personal",
    component: () => import("/app/pages/[_lang]/[_city]/Personal.vue")
  },
  {
    name: "webview-_lang-_city-date",
    path: "/webview/:_lang()/:_city()/date",
    meta: dateWTIvyk3znnKOL6UxYYsiuma5MXnNkxtZK9ECftxBXmsMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/date.vue")
  },
  {
    name: "webview-_lang-_city-Final",
    path: "/webview/:_lang()/:_city()/Final",
    meta: Final88dCcBfMrk3QT_4512qFwUk1Bpw4bRDVdBXIMI6u2h5hUMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Final.vue")
  },
  {
    name: "webview-_lang-_city-Options",
    path: "/webview/:_lang()/:_city()/Options",
    meta: OptionslubZpzDUrO_45Qwr_45jGQLEYc_45MrTON6SdWOdqV3Zn5hS0Meta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Options.vue")
  },
  {
    name: "webview-_lang-_city-Summary",
    path: "/webview/:_lang()/:_city()/Summary",
    meta: SummarysrlaR9EQ8MpbUuKGYgNbalnCb2EjB1SknJIBrLF_45_45YAMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Summary.vue")
  },
  {
    name: "webview-_lang-_city-Category",
    path: "/webview/:_lang()/:_city()/Category",
    meta: Categoryxh0ZlB4Lo8KCfAgdSznBWPqipoOe550Q_lyJs_45Qk9DoMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Category.vue")
  },
  {
    name: "webview-_lang-_city-Coverage",
    path: "/webview/:_lang()/:_city()/Coverage",
    meta: Coverage0u8RwHPfRHfQXBn_rqWRAMisf8xWgAdTfx5_459NIrG6wMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Coverage.vue")
  },
  {
    name: "webview-_lang-_city-service-select",
    path: "/webview/:_lang()/:_city()/service/select",
    meta: select7k7JIfhwNhutI578stcJp4JF_RcsNFITIhbCOjnhykEMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/service/select.vue")
  },
  {
    name: "webview-_lang-_city-service-onboarding",
    path: "/webview/:_lang()/:_city()/service/onboarding",
    meta: onboarding_PKGOFRkvCziv5ey_45nLcAceI29kGuPZDSkwa9MaIyZwMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/service/onboarding.vue")
  }
]